<template>
    <app-layout title="Beheer">
        <template #header>
            <page-title title="Product opties" />
        </template>

        <template #pageContent>
            <p>Dit zijn de prijzen die gebruikt worden voor de prijsberekening wanneer er een order vanuit een koppeling met een partner binnenkomt, bv. CIB of Whise.</p>

            <Form @submitted="storePrices" class="w-full w-1/2">
                <Table id="webshop-product-surface-prices" :values="surfaces">
                    <thead>
                    <Th id="size">Oppervlakte gebouw</Th>
                    <template v-for="webshop in webshops">
                        <Th :id="'price_' + webshop.code" class="w-[150px]">Prijs {{ webshop.code.toUpperCase() }}</Th>
                    </template>
                    </thead>
                    <tbody>
                    <tr v-for="(surface, key) in state.sortedValues['webshop-product-surface-prices']" :key="key">
                        <Td v-html="surface.size"></Td>
                        <Td v-for="webshop in webshops">
                            <div class="flex">
                                <span class="flex items-center mb-2 mr-1">&euro;</span>
                                <Input
                                    type="number"
                                    :name="'surface_price_' + webshop.code"
                                    :required="true"
                                    min="0"
                                    :step="0.01"
                                    v-model="formsSurfaces[surface.id + '-' + webshop.code].price"
                                    :error="formsSurfaces[surface.id + '-' + webshop.code].errors.price"
                                />
                            </div>
                        </Td>
                    </tr>
                    </tbody>
                </Table>

                <Table id="webshop-product-research-type-prices" :values="researchTypes" class="mt-8">
                    <thead>
                    <Th id="nl">Welk soort asbestonderzoek wens je?</Th>
                    <template v-for="webshop in webshops">
                        <Th :id="'price_' + webshop.code" class="w-[150px]">Prijs {{ webshop.code.toUpperCase() }}</Th>
                    </template>
                    </thead>
                    <tbody>
                    <tr v-for="(researchType, key) in state.sortedValues['webshop-product-research-type-prices']" :key="key">
                        <Td v-html="researchType.nl"></Td>
                        <Td v-for="webshop in webshops">
                            <div class="flex">
                                <span class="flex items-center mb-2 mr-1">&euro;</span>
                                <Input
                                    type="number"
                                    :name="'researchType_price_' + webshop.code"
                                    :required="true"
                                    min="0"
                                    :step="0.01"
                                    v-model="formsResearchTypes[researchType.id + '-' + webshop.code].price"
                                    :error="formsResearchTypes[researchType.id + '-' + webshop.code].errors.price"
                                />
                            </div>
                        </Td>
                    </tr>
                    </tbody>
                </Table>

                <Table id="webshop-product-procedure-prices" :values="procedures" class="mt-8">
                    <thead>
                    <Th id="nl">Wenst u een spoedprocedure?</Th>
                    <template v-for="webshop in webshops">
                        <Th :id="'price_' + webshop.code" class="w-[150px]">Prijs {{ webshop.code.toUpperCase() }}</Th>
                    </template>
                    </thead>
                    <tbody>
                    <tr v-for="(procedure, key) in state.sortedValues['webshop-product-procedure-prices']" :key="key">
                        <Td v-html="procedure.nl"></Td>
                        <Td v-for="webshop in webshops">
                            <div class="flex">
                                <span class="flex items-center mb-2 mr-1">&percnt;</span>
                                <Input
                                    type="number"
                                    :name="'procedure_price_' + webshop.code"
                                    :required="true"
                                    min="0"
                                    :step="0.01"
                                    v-model="formsProcedures[procedure.id + '-' + webshop.code].price"
                                    :error="formsProcedures[procedure.id + '-' + webshop.code].errors.price"
                                />
                            </div>
                        </Td>
                    </tr>
                    </tbody>
                </Table>

                <div class="inline-block self-end mt-4">
                    <Button
                        text="Opslaan"
                        buttonType="submit"
                        buttonClass="save"
                        :loading="processing"
                    />
                </div>
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import Input from '@/Components/Input.vue'
import Form from '@/Components/Form.vue'

import store from '@/store'
import { useForm } from '@inertiajs/inertia-vue3'
import { ref } from "vue"
import { Inertia } from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        Input,
        Form,
    },
    props: [
        'webshops',
        'surfaces',
        'researchTypes',
        'procedures',
    ],
    setup (props, { attrs })
    {
        let processing = ref(false)
        let formsSurfaces = []
        let formsResearchTypes = []
        let formsProcedures = []

        props.webshops.forEach(function(webshop, i) {
            props.surfaces.forEach(function(surface, i) {
                formsSurfaces[surface.id + '-' + webshop.code] = useForm({
                    id: surface.id,
                    webshop_code:  webshop.code,
                    price: surface['price_' + webshop.code],
                })
            })

            props.researchTypes.forEach(function(researchType, i) {
                formsResearchTypes[researchType.id + '-' + webshop.code] = useForm({
                    id: researchType.id,
                    webshop_code:  webshop.code,
                    price: researchType['price_' + webshop.code] ?? 0,
                })
            })

            props.procedures.forEach(function(procedure, i) {
                formsProcedures[procedure.id + '-' + webshop.code] = useForm({
                    id: procedure.id,
                    webshop_code:  webshop.code,
                    price: procedure['price_' + webshop.code] ?? 0,
                })
            })
        })



        function storePrices()
        {
            const forms = [formsSurfaces, formsResearchTypes, formsProcedures]
            let valid = true;
            processing.value = true

            //Validation
            forms.forEach(function(form){
                Object.keys(form).forEach(function(key, i) {

                    if (form[key].price === null)
                    {
                        form[key].errors.price = 'Prijs is verplicht.'
                        valid = false
                    }
                    else if(isNaN(form[key].price)) {
                        form[key].errors.price = 'Prijs heeft een ongeldige waarde.'
                        valid = false
                    }
                });
            })

            if (valid) {
                let storeSuccess = true
                const optionsForms = {
                    'surface':formsSurfaces,
                    'research-type': formsResearchTypes,
                    'procedure': formsProcedures,
                }

                //Save
                for (const [type, form] of Object.entries(optionsForms))
                {
                    Object.keys(form).forEach(function(key, i) {
                        //We use Axios here, because we can't send multiple requests with inertia
                        axios.post('/configuration/webshop-products/product-options/store-' + type + '-price', {
                            id: form[key].id,
                            webshop_code: form[key].webshop_code,
                            price: form[key].price
                        })
                            .then(response => {
                                console.log(response.data);
                            })
                            .catch(error => {
                                storeSuccess = false
                                console.error(error);
                            });
                    })
                }

                if (storeSuccess)
                {
                    attrs.flash.success = 'De prijzen zijn opgeslagen.'
                }
                else
                {
                    attrs.flash.error = 'Er ging iets mis, probeer opnieuw.'
                }
            }

            processing.value = false
        }

        return {
            state: store.state,
            ...store,
            processing,
            formsSurfaces,
            formsResearchTypes,
            formsProcedures,
            storePrices,
        }
    },
}

</script>
